import {accountName} from './unminify'

// companies whose sub-accounts (name before ':') collapse into one contact option
const GROUPED_ACCOUNT_PARENTS = ['BELLA NY']

// returns the parent name if this account belongs to a grouped company, otherwise the full name
const accountParent = (name) => {
  if (name == null) return name
  let parent = name.split(':')[0]
  return GROUPED_ACCOUNT_PARENTS.includes(parent) ? parent : name
}

const getAccountOptions = (shippedData, salesOrderData) => {
  let accountNames = getAccountNames(shippedData).concat(getAccountNames(salesOrderData))
  let distinctAccounts = [...new Set(accountNames)]
  return distinctAccounts.sort().map(x => ({key: x, text: x, value: x}))
}

// like getAccountOptions but collapses grouped companies (e.g. BELLA NY) into a single option
const getGroupedAccountOptions = (shippedData, salesOrderData) => {
  let parents = getAccountNames(shippedData).concat(getAccountNames(salesOrderData)).map(accountParent)
  let distinctParents = [...new Set(parents)]
  return distinctParents.sort().map(x => ({key: x, text: x, value: x}))
}

const getAccountNames = (salesData) => {
  return Object.values(salesData).map(orders => orders.map(order => accountName(order))).flat()
}

export {getAccountOptions, getGroupedAccountOptions, accountParent}
